/**
 * TanStack Router: /revfinops/clients/new
 *
 * This route file was auto-generated by the route generation script.
 * Component: RevFinOpsClientsNewPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import RevFinOpsClientsNewPage from '@/app/revfinops/clients/new/page'

/**
 * Route: /revfinops/clients/new
 * Layout: _auth (authenticated)
 * Component: RevFinOpsClientsNewPage
 */
export const Route = createFileRoute('/_auth/revfinops/clients/new')({
  component: RevFinOpsClientsNewPage,
})
